// Renders a refined color swatch with a subtle inner highlight.
function ColorBox({ color, size = "h-9 w-9" }) {
  return (
    <span
      style={{ backgroundColor: color }}
      className={`relative inline-block ${size} overflow-hidden rounded-lg ring-1 ring-black/5 dark:ring-white/10`}
    >
      <span
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/20 to-transparent"
      />
    </span>
  );
}

export default ColorBox;
